import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { UiPlatformButtonComponent } from '../button/button.component';
import { UiPlatformMenuComponent } from '../menu/menu.component';
import { UiPlatformMenuItems } from '../menu/menu.model';
import { UiPlatformStatusMarkerStateEnum } from '../status-marker/enums/status-marker.enums';
import { UiPlatformStatusMarkerModule } from '../status-marker/status-marker.module';

const DRAWER_SIZES = {
  'normal': 512,
  'wide': 736,
  'ultra-wide': 1024
};

@Component({
  selector: 'ui-platform-drawer',
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NzDrawerModule,
    UiPlatformButtonComponent,
    UiPlatformMenuComponent,
    UiPlatformStatusMarkerModule,
    TranslocoPipe
  ]
})
export class UiPlatformDrawerComponent {
  @Input() cancelLabel = 'general.cancel';
  @Input() confirmLabel = 'general.change';
  @Input() inProgress = false;
  @Input() isConfirmButtonVisible = true;
  @Input() showButtons = true;
  @Input() title = '';
  @Input() visible = false;
  @Input() menuItems: UiPlatformMenuItems = [];
  @Input() currentStatus: UiPlatformStatusMarkerStateEnum | null = null;
  @Input() statusItems: UiPlatformMenuItems = [];

  @Input() set size(size: keyof typeof DRAWER_SIZES) {
    if (!DRAWER_SIZES[size]) {
      return;
    }

    this.drawerWidth = DRAWER_SIZES[size];
  }

  @Output() closeDrawer = new EventEmitter();
  @Output() confirmDrawer = new EventEmitter();

  drawerWidth = DRAWER_SIZES['normal'];

  onCloseButtonClick() {
    this.closeDrawer.emit();
  }

  onConfirmButtonClick() {
    this.confirmDrawer.emit();
  }
}
